import React, { useEffect, useState } from "react";
import { dataFormat } from "../../functions/dataFormat";
import { zaokr } from "../../functions/utilities";
import logo from '../../images/Biuro  obsługi nieruchomości_Mojsiewicz&Stanek_logo ok_przezroczyste.png'
 

const WynikiGlosowaniaA4 = props => {

    const { componentRef, tablicaMieszkancyUdzialy, activeCard, wspolnota } = props;


    const udzialyRazem = tablicaMieszkancyUdzialy.reduce((acc, obj) => acc + obj.udzialProc, 0);
    const udzialyGlosujace = tablicaMieszkancyUdzialy.reduce((acc, obj) => obj.czyOdp == 1 ? acc + obj.udzialProc :  acc + 0, 0);
    
    return (
        <div    
            style={{
                width: '21cm',
                height: '29.7cm',
                backgroundColor: 'white',
                // boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                padding: '15mm 15mm',
                boxSizing: 'border-box',
                maxWidth: '100%',
                maxHeight: '100%',
                fontFamily: "Roboto, sans-serif", 
                marginBottom: "10px",
                fontSize: "13px"
            }} 
            ref={componentRef ? componentRef : null}
        >
            <style>
                {`
                @media print {
                    input[type="date"]::-webkit-calendar-picker-indicator {
                    display: none;
                    }

                    input[type="date"] {
                    -webkit-appearance: none;
                    -moz-appearance: textfield;
                    }
                }
                `}
            </style>
            <section
                style={{
                    textAlign: "right"
                }}
            >
                <img 
                    src={logo}
                    alt="logo"
                    width="150px"
                    height="auto"
                />
            </section>
            <section style={{marginTop: "30px"}}>
                <div>
                    <p style={{
                        textAlign: "left", 
                        fontSize: "17px", 
                        marginBottom: "30px", 
                        textIndent: "60px", 
                        lineHeight: "2rem"
                    }}>
                        {`Prodokół z głosowania nad uchwałami w trybie indywidualnego zbierania głosów nad uchwałami z zebrania ${wspolnota.name} w Gorzowie Wlkp. z dnia `}
                        <input 
                            style={{
                                border: "none",
                                display: "inline",
                                fontSize: "17px",
                                width: "120px",
                                fontFamily: "Roboto, sans-serif",
                                color: "black",
                                padding: "0"
                                
                            }}
                            type="date"
                        />
                    </p>
                </div>

                    
                <p style={{textAlign: "left", fontSize: "17px", marginBottom: "30px", textIndent: "60px", lineHeight: "2rem"}}>
                    {`Głosowanie zostało przeprowadzone w Systemie Wspólnota bonadministrator.pl do dnia ${dataFormat(activeCard?.data_do)}.`}
                </p>
                <p style={{textAlign: "left", fontSize: "17px", marginBottom: "30px", textIndent: "60px", lineHeight: "2rem"}}>
                    W załączeniu uchwały z wynikami głosowania zdalnego oraz głosami oddanymi na zebraniu Wspólnoty.
                </p>
                <p style={{textAlign: "left", fontSize: "17px", marginBottom: "30px", textIndent: "60px", lineHeight: "2rem"}}>
                    {`Razem oddanych głosów liczonych według udziałów: ${udzialyGlosujace}, co stanowi ${ zaokr( udzialyGlosujace / udzialyRazem, 2 ) }%.`}
                </p>
            </section>

        </div>
    )
}

export default WynikiGlosowaniaA4;